import React, { useEffect } from 'react';
import { CareTeamProvider } from './care-team/store/CareTeamProvider';
import { LoadingIndicator } from '@xolv-mybrightlink/common';
import { useCurrentUserGuid } from '../firebase/useCollection';
import { useChannelListener } from './care-team/hooks/firebase/useChannelListener';
import { useFetchPatients } from './care-team/hooks/store/useFetchPatients';
import { useCareTeam } from './care-team/hooks/store/useCareTeam';
import { useFetchCareTeamMembers } from './care-team/hooks/store/useFetchCareTeamMembers';
import { useFetchPatientContacts } from './care-team/hooks/store/useFetchPatientContacts';
import { useFetchCcmDetails } from './care-team/hooks/store/useFetchCcmDetails';
import { MessageStandaloneDisplayConfigProvider } from './care-team/message-bar/MessageStandaloneDisplayConfigProvider';

const CareTeamInit = (props: { children: React.ReactNode }) => {
  const [store, dispatch] = useCareTeam();
  const currentUserGuid = useCurrentUserGuid();
  useEffect(() => {
    if (store === 'LOADING') {
      dispatch({ type: 'INIT', currentUserGuid });
    }
  }, [store, dispatch, currentUserGuid]);
  useFetchPatients();
  useFetchCareTeamMembers();
  useFetchPatientContacts();
  useFetchCcmDetails();
  useChannelListener();

  if (store === 'LOADING') {
    return <LoadingIndicator fullHeight />;
  }
  return <>{props.children}</>;
};

export const CareTeam = (props: { children: React.ReactNode }) => {
  return (
    <MessageStandaloneDisplayConfigProvider>
      <CareTeamProvider>
        <CareTeamInit>{props.children}</CareTeamInit>
      </CareTeamProvider>
    </MessageStandaloneDisplayConfigProvider>
  );
};
